import EmptyMessage from 'components/EmptyMessage'
import Screen from 'components/layout/Screen'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import API from 'state/API'
import { usePlainEffect } from 'utils'

export default function TermsPage() {
	const { t }             = useTranslation()
	const [terms, setTerms] = useState('')

	usePlainEffect(() => API.get('account/terms').then(data => setTerms(data.data)))

	return <Screen title={t('Terms of Service')} back>
		<Screen.Content addPadding>
			{terms?
				<div dangerouslySetInnerHTML={{ __html: terms }}/>
			:
				<EmptyMessage icon="ellipsis-h" resource={API.RESOURCES.ACCOUNT} msg="Loading terms"/>
			}
		</Screen.Content>
	</Screen>
}
